import React from "react";
import styles from "./ItemAvailabilityBadge.module.scss";

interface ItemAvailabilityBadgeProps {
  shortCode?: string;
  color?: string;
  needRP?: number;
  description?: string;
  onClick?: () => void;
}

export const ItemAvailabilityBadge: React.FC<ItemAvailabilityBadgeProps> = ({
  shortCode,
  color,
  needRP,
  description,
  onClick,
}) => {
  // Only render if shortCode exists
  if (!shortCode) {
    return null;
  }

  const isHighlighted = needRP === 1;
  const backgroundColor = isHighlighted ? color : "transparent";
  const textColor = isHighlighted ? "white" : color;
  const isClickable = !!onClick;

  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.stopPropagation();
      onClick();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }
  };

  return (
    <span
      className={`${styles.badge} ${isClickable ? styles.clickable : ""}`}
      style={{
        borderColor: color,
        backgroundColor,
        color: textColor,
      }}
      title={description || shortCode}
      onClick={handleClick}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onKeyDown={isClickable ? handleKeyDown : undefined}
    >
      {shortCode}
    </span>
  );
};

export default ItemAvailabilityBadge;
